import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Tick(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M7.8 22.35c-.397 0-.778-.157-1.061-.44l-6.3-6.3a1.5 1.5 0 112.122-2.12l5.131 5.13 13.65-16.573a1.5 1.5 0 112.316 1.907l-14.7 17.849a1.497 1.497 0 01-1.159.547"
  }));
}

export { Tick };
//# sourceMappingURL=Tick.js.map